import React from 'react';

function Home() {
  return (
    <div>
      <h1 className="home-head">Welcome to our page!</h1>
      <p className="desc">
        Math is beautiful. But sometimes, this can be hard to see, and even harder to convey to
        students who don’t — yet — share your passion.

        In addition to math books, using math quotes in your daily instruction is one of
        many ways to get students excited about this oft-dreaded subject.
        Mathematics as an expression of the human mind reflects the active will,
        the contemplative reason, and the desire for aesthetic perfection.
        Its basic elements are logic and intuition, analysis and construction,
        generality and individuality.
      </p>
      <p className="desc desc2">
        Over the centuries, some of the world’s brightest minds have shared wise words that
        remain relevant to this day!
        We’ve compiled a list of our favorite quotes about math for teachers and students alike!

        Inspire, motivate, and humor your students with these math quotes!
        We will always have STEM with us. Some things will drop out of the public eye and go away,
        but there will always be science, engineering, and technology. And there will always,
        always be mathematics.
      </p>
    </div>
  );
}

export default Home;
